import { SectionA } from './Styled'
import { H3 } from 'components/generic/HomePageComponents'
import { SectionDiv } from './SectionDiv'

export const Section = ({ section: { navigation_items, title } }) => {
  const items =
    navigation_items &&
    navigation_items.length > 0 &&
    navigation_items.map((nav_item, index) => (
      <SectionA key={index} href={nav_item.link}>
        {nav_item.title}
      </SectionA>
    ))

  return (
    <>
      <H3 color='white'>{title}</H3>
      <SectionDiv title={title} length={items.length}>
        {items}
      </SectionDiv>
    </>
  )
}
